import html2canvas from 'html2canvas';
import RenderProvider from './render';

export default class Share {
    static instance = null;

    private renderProvider: RenderProvider;

    constructor() {
        this.renderProvider = RenderProvider.getInstance();
    }

    static getInstance(): Share {
        if (!this.instance) {
            this.instance = new Share();
        }

        return this.instance;
    }

    static async drawElementToCanvas(element: Element): Promise<HTMLCanvasElement> {
        return html2canvas(element as HTMLElement, {
            scale: 1,
            useCORS: true,
            allowTaint: false,
            windowWidth: 1152,
            windowHeight: 2070,
        });
    }

    static async shareBlob(blobImageAsset: Blob, filename: string): Promise<void> {
        return new Promise((resolve, reject) => {
            const filesArray = [
                new File([blobImageAsset], `${filename}.jpeg`, {
                    type: 'image/jpeg',
                    lastModified: new Date().getTime(),
                }),
            ];
            const shareData = {
                files: filesArray,
            };

            if (navigator.canShare && navigator.canShare(shareData)) {
                navigator.share(shareData)
                    .then(resolve)
                    .catch(reject);
            } else {
                reject();
            }
        });
    }
}
